// extracted by mini-css-extract-plugin
export default {"tupacGrid":"tl-z","tupacHeader":"ul-z","tupacHeader2":"vl-z","tupacMenu":"wl-z","tupacMenu2":"xl-z","tupacMain":"yl-z","tupacMain2":"zl-z"};